// src/contexts/OrgContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { db } from "../services/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { useAuth } from "./AuthContext";

const OrgContext = createContext();
export const useOrg = () => useContext(OrgContext);

export function OrgProvider({ children }) {
  const { orgId, currentUser } = useAuth();
  const [organisation, setOrganisation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orgId || !currentUser) { setLoading(false); return; }

    let mounted = true;

    currentUser.getIdToken(true).then(() => {
      if (!mounted) return;

      const unsub = onSnapshot(
        doc(db, "organisations", orgId),
        (snap) => {
          if (mounted) {
            setOrganisation(snap.exists() ? { id: snap.id, ...snap.data() } : null);
            setLoading(false);
          }
        },
        () => { if (mounted) setLoading(false); }
      );

      return () => unsub();
    }).catch(() => {
      if (mounted) setLoading(false);
    });

    return () => { mounted = false; };
  }, [orgId, currentUser]);

  return (
    <OrgContext.Provider value={{
      organisation,
      // membres retirés — maintenant dans TombolaContext
      loading,
    }}>
      {children}
    </OrgContext.Provider>
  );
}
